/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What happened to one problem of a statement update.
 * @export
 */
export const StatementUpdateStatus = {
    Updated: 'updated',
    NotInCompetition: 'not_in_competition',
    NotOwner: 'not_owner',
    NotFound: 'not_found'
} as const;
export type StatementUpdateStatus = typeof StatementUpdateStatus[keyof typeof StatementUpdateStatus];


export function instanceOfStatementUpdateStatus(value: any): boolean {
    for (const key in StatementUpdateStatus) {
        if (Object.prototype.hasOwnProperty.call(StatementUpdateStatus, key)) {
            if (StatementUpdateStatus[key as keyof typeof StatementUpdateStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatementUpdateStatusFromJSON(json: any): StatementUpdateStatus {
    return StatementUpdateStatusFromJSONTyped(json, false);
}

export function StatementUpdateStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementUpdateStatus {
    return json as StatementUpdateStatus;
}

export function StatementUpdateStatusToJSON(value?: StatementUpdateStatus | null): any {
    return value as any;
}

export function StatementUpdateStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): StatementUpdateStatus {
    return value as StatementUpdateStatus;
}

